import { measureText } from "../util";

export const VCHART_UTILS = {
    measureText: measureText
};
//# sourceMappingURL=util.js.map
